import { type CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { md, lg },
} = constants.breakpoints;

export const horizontalContainerCss: CSSObject = {
  height: "392px",
  [mediaQuery.upTo(md)]: {
    width: "calc(100vw - 6rem)",
  },
  width: "940px",
  overflowX: "auto",
  overflowY: "hidden",
};

export const scrollablePanel: CSSObject = {
  display: "flex",
  justifyContent: "center",
  flexFlow: "row nowrap",
  alignItems: "center",
  position: "relative",
};

export const scrollLeftCss: CSSObject = {
  position: "absolute",
  left: "-3rem",
  [mediaQuery.upTo(lg)]: {
    left: "-2rem",
  },
};

export const scrollRightCss: CSSObject = {
  position: "absolute",
  right: "-3rem",
  [mediaQuery.upTo(lg)]: {
    right: "-2rem",
  },
};
